import { PillProps } from '@procore/core-react/dist/_typedoc/Pill/Pill.types.json';
import * as React from 'react';
export default {
  PillProps,
  React
};